<template>
    <a-modal :title="state.modalTitle" :width="1200" :open="true" @ok="onFormSubmit" :confirmLoading="state.loading"
        @cancel="
            () => {
                emit('cancel')
            }
        ">
        <template #footer>
            <a-button size="middle" @click="
                () => {
                    emit('cancel')
                }
            ">取消</a-button>

            <a-button size="middle" type="primary" @click="onFormSubmit()" :loading="state.finishLoading"
                :disabled="state.finishLoading">确定</a-button>
        </template>
        <a-spin :spinning="loading">
            <a-form ref="formRef" v-bind="formLayout" :model="formState" :rules="rules">
                <a-row><a-col :span="12"><a-form-item required label="工单标题" name="title">
                            <a-input v-model:value="formState.title" placeholder="请输入工单标题"></a-input>
                        </a-form-item></a-col>
                    <a-col :span="12"> <a-form-item label="紧急情况">
                            <a-radio-group button-style="solid" v-model:value="formState.critical_situation">
                                <a-radio-button :value="1">不急</a-radio-button>
                                <a-radio-button :value="2">普通</a-radio-button>
                                <a-radio-button :value="3">紧急</a-radio-button>
                                <a-radio-button :value="4">最高级</a-radio-button>
                            </a-radio-group>
                        </a-form-item></a-col>
                    <a-col :span="12"> <a-form-item label="工单类型（大类）" name="type">
                            <a-radio-group v-model:value="formState.type" button-style="solid" @change="change">
                                <a-radio-button :value="3">代办事项</a-radio-button>
                                <a-radio-button :value="1">投诉</a-radio-button>
                                <a-radio-button :value="2">举报</a-radio-button>
                            </a-radio-group>
                        </a-form-item></a-col>
                    <a-col :span="12"><a-form-item label="工单类型（小类）" required>
                            <a-select allow-clear ref="select" v-model:value="formState.wo_type">
                                <a-select-option :value="1"
                                    v-if="formState.type == 1 || formState.type == 2">经营纠纷</a-select-option>
                                <a-select-option :value="2"
                                    v-if="formState.type == 1 || formState.type == 2">网络卖课</a-select-option>
                                <a-select-option :value="3"
                                    v-if="formState.type == 1 || formState.type == 2">疑似诈骗</a-select-option>
                                <a-select-option :value="4"
                                    v-if="formState.type == 1 || formState.type == 2">疑似银行类犯罪</a-select-option>
                                <a-select-option :value="6"
                                    v-if="formState.type == 1 || formState.type == 2">虚假宣传</a-select-option>
                                <a-select-option :value="7"
                                    v-if="formState.type != 1 && formState.type != 2">主体信息变动尽调</a-select-option>
                                <a-select-option :value="8"
                                    v-if="formState.type != 1 && formState.type != 2">收到执照、章</a-select-option>
                                <a-select-option :value="9"
                                    v-if="formState.type != 1 && formState.type != 2">收到包裹</a-select-option>
                                <a-select-option :value="10"
                                    v-if="formState.type != 1 && formState.type != 2">申报异常</a-select-option>
                                <a-select-option :value="11"
                                    v-if="formState.type != 1 && formState.type != 2">移出异常</a-select-option>
                                <a-select-option :value="12"
                                    v-if="formState.type != 1 && formState.type != 2">日常管理巡查</a-select-option>
                                <a-select-option :value="5">其他</a-select-option>
                            </a-select>
                        </a-form-item></a-col>
                </a-row>
                <a-form-item required label="其他具体事项名称" name="wo_type_son" v-if="formState.wo_type == 5">
                    <a-input v-model:value="formState.wo_type_son" placeholder="请输入其他具体代办事项名称"></a-input>
                </a-form-item>
                <a-row>
                    <a-col :span="12"> <a-form-item required label="信息来源情况" name="source">
                            <a-input v-model:value="formState.source" placeholder="请输入信息来源情况"></a-input>
                        </a-form-item></a-col>
                    <a-col :span="12"> <a-form-item label="工单服务对象" v-if="state.isEdit">
                            {{ formState.customer_info['full_name'] }}
                        </a-form-item>
                        <a-form-item label="工单服务对象" v-if="!state.isEdit">
                            <SelectCompany :isEdit="false" :selectCheck="formState.customer_ids"
                                @change="SelectCompanyChange">
                            </SelectCompany>
                        </a-form-item></a-col>

                </a-row>

                <a-row>
                    <a-col :span="12"> <!-- 如果是多个公司，则后端自动匹配各自的销售 -->
                        <a-form-item label="归属销售" name="reception_admin_ids" required
                            v-if="formState.customer_ids.length <= 1">
                            <UserPick v-model:value="formState.reception_admin_ids" mode="multiple"
                                placeholder="请输入归属销售姓名或手机号码">
                            </UserPick>
                        </a-form-item></a-col>
                    <a-col :span="12"> <a-form-item label="工单执行负责人" name="custodian_admin_ids" required>
                            <UserPick v-model:value="formState.custodian_admin_ids" mode="multiple"
                                placeholder="请输入工单执行负责人姓名或手机号码">
                            </UserPick>
                        </a-form-item></a-col>

                    <a-col :span="12"><a-form-item label="开始时间" name="start_time" required>
                            <a-date-picker :show-time="{ defaultValue: arrayMonent }"
                                v-model:value="formState.start_time" placeholder="请选择开始日期"></a-date-picker>
                        </a-form-item></a-col>
                    <a-col :span="12"><a-form-item label="截止完成时间" name="end_time" required>
                            <a-date-picker :show-time="{ defaultValue: arrayMonent }" v-model:value="formState.end_time"
                                placeholder="请选择截止日期"></a-date-picker>
                        </a-form-item></a-col>
                    <a-col :span="12"><a-form-item label="工单内容" name="content">
                            <a-textarea :rows="3" placeholder="请输入工单内容" v-model:value="formState.content"> </a-textarea>
                        </a-form-item></a-col>
                    <a-col :span="12"> <a-form-item label="机密内容">
                            <a-textarea placeholder="请输入机密内容" v-model:value="formState.secret_content" :rows="3">
                            </a-textarea>
                        </a-form-item></a-col>


                    <a-col :span="12"> <a-form-item :label="(formState.type == 1 ? '投诉' : '举报') + '人姓名'"
                            name="tousu_name" v-if="formState.type == 1 || formState.type == 2">
                            <a-input v-model:value="formState.tousu_name"
                                :placeholder="'请输入' + (formState.type == 1 ? '投诉人' : '举报人') + '姓名'"
                                @change="titleformat"></a-input>
                        </a-form-item></a-col>
                    <a-col :span="12"> <a-form-item :label="(formState.type == 1 ? '投诉' : '举报') + '人电话'"
                            name="tousu_tel" v-if="formState.type == 1 || formState.type == 2"><a-input
                                v-model:value="formState.tousu_tel"
                                :placeholder="'请输入' + (formState.type == 1 ? '投诉人' : '举报人') + '电话'"
                                @change="titleformat"></a-input>
                        </a-form-item></a-col>
                    <a-col :span="12"> <a-form-item label="附件">
                            <Upload :upload_path="props.counterfeitInfo ? props.counterfeitInfo.upload_path :
                                `public/uploads/manage/工单/${dayjs().format('YYYYMM')}/`"
                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                v-model:value="formState.attachment" uploadType="text" :limitation="9"
                                uploadText="上传附件">
                            </Upload>
                        </a-form-item></a-col><a-col :span="12"><a-form-item label="涉及金额" name="tousu_money"
                            v-if="formState.type == 1 || formState.type == 2">
                            <a-input v-model:value="formState.tousu_money" placeholder="请输入涉及金额" @change="titleformat"
                                prefix="￥" suffix="元"></a-input>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup>
import cloneDeep from 'lodash.clonedeep'
import { Upload, SelectCompany } from '@/components'
import baseService from '@/utils/http/axios'
import { message } from 'ant-design-vue'
import { ref, reactive, onMounted, watch } from 'vue'
import UserPick from '@/components/base/UserPick.vue'
import { debounce } from 'lodash-es'
import dayjs from 'dayjs'
import { platform } from 'os'
const emit = defineEmits(['cancel', 'ok'])
const arrayMonent = dayjs('00:00:00', 'HH:mm:ss')
const format = 'YYYY-MM-DD HH:mm:ss'
const startTime = dayjs()
const endTime = dayjs().add(1, 'day')

const rules = {
    type: [
        {
            required: true,
            message: '请选择工单类型'
        }
    ],
    content: [
        {
            required: false,
            message: '请输入工单内容'
        }
    ]
}
interface formState {
    title: string
    source: string
    customer_info: object
    type: number
    wo_type: number | null
    customer_ids: any[]
    start_time: any
    end_time: any
    content: string
    custodian_admin_ids: any[]
    reception_admin_ids: any[]
    secret_content: string
    attachment: any[]
    critical_situation: number
    wo_type_son: string
    tousu_name: string | null
    tousu_tel: string | null
    tousu_money: string | null
}
const formState = reactive<formState>({
    title: '有投诉，请及时处理',
    source: '12345或工商所',
    customer_info: [],
    type: 1,
    wo_type: 1,
    customer_ids: [],
    critical_situation: 2,
    end_time: dayjs().subtract(-2, 'day'),
    start_time: startTime,
    content: '',
    custodian_admin_ids: [],
    reception_admin_ids: [],
    secret_content: '',
    attachment: [],
    wo_type_son: '',
    tousu_name: '',
    tousu_tel: '',
    tousu_money: ''
})
const props = defineProps({
    detailData: {
        type: Object
    },
    loading: {
        type: Boolean,
        default: () => false
    },
    model: {
        type: Object,
        default: () => null
    },
    counterfeitInfo: {
        type: Object,
        default: () => null
    }
})
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
    }
}
onMounted(() => {
    if (props.detailData?.id) {
        state.isEdit = true
        state.modalTitle = '编辑工单'
        queryDetail(props.detailData.id)
    }
    if (props.counterfeitInfo) {
        formState.customer_ids.push({ id: props.counterfeitInfo.customer_id, name: props.counterfeitInfo.full_name })
        formState.reception_admin_ids.push(props.counterfeitInfo.seller_id)
        //获取平台的异常投诉专员
        let requestParam = {
            url: '/admin/v1/workOrder/getPlatformYctsAdmin',
            method: 'post',
            data: {
                platform_id: props.counterfeitInfo.platform_id
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                formState.custodian_admin_ids = res.data
            })
            .catch((res) => { })
    }
})
const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/workOrder/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam).then((res) => {
        state.loading = false
        res.data.end_time = dayjs(res.data.end_time, format)
        res.data.start_time = dayjs(res.data.start_time, format)
        Object.assign(formState, res.data)
    })
}

const formRef = ref()
const state = reactive<any>({
    loading: false,
    isEdit: false,
    modalTitle: '新增工单',
    userList: [],
    finishLoading: false
})
const SelectCompanyChange = (val: any[]) => {
    formState.customer_ids = val.map((res) => {
        return { id: res.id, name: res.name, seller_id: res.seller_id }
    })
    //归属代理商
    if (formState.customer_ids.length == 1) {
        formState.reception_admin_ids = [formState.customer_ids[0].seller_id]
    }
}
const change = (val) => {
    if (val.target.value == 1) {
        formState.critical_situation = 3
        formState.wo_type = 1
        formState.source = '12345或工商所'
    } else if (val.target.value == 2) {
        formState.critical_situation = 4
        formState.wo_type = 1
        formState.source = '12345或工商所'
    } else {
        formState.critical_situation = 2
        formState.wo_type = null
        formState.source = '办公室'
    }
    if (!formState.title) {
        if (formState.type == 1 || formState.type == 2) {
            formState.title = '【' + formState.tousu_name + (formState.tousu_tel ? ' ' + formState.tousu_tel : '') + '】' + typeMap.get(formState.type) + (formState.tousu_money ? '，涉及金额【' + formState.tousu_money + '元】' : '') + '，请及时处理'
        } else {
            formState.title = props.counterfeitInfo.full_name + '有' + typeMap.get(formState.type) + '，请及时处理'
        }
    }
}

const onFormSubmit = () => {
    formRef.value
        .validate()
        .then((errors, values) => {
            let data = cloneDeep(formState)
            data.start_time = dayjs(data.start_time).format(format)
            data.end_time = dayjs(data.end_time).format(format)
            if (props.detailData?.id) {
                let requeryParam = {
                    url: '/admin/v1/workOrder/' + props.detailData.id,
                    method: 'put',
                    data: data
                }
                state.loading = true
                state.finishLoading = true
                baseService(requeryParam)
                    .then((res: any) => {
                        message.success(res.msg)
                        emit('ok')
                        state.loading = false
                        state.finishLoading = false
                    })
                    .catch((res) => {
                        state.loading = false
                        state.finishLoading = false
                        if (res.data) {
                            message.warning('参数错误,请检查')
                        } else {
                            message.warning(res.msg)
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/workOrder',
                    method: 'post',
                    data: data
                }
                state.loading = true
                state.finishLoading = true
                baseService(requeryParam)
                    .then((res: any) => {
                        message.success(res.msg)
                        emit('ok')
                        state.loading = false
                        state.finishLoading = false
                    })
                    .catch((res) => {
                        state.loading = false
                        state.finishLoading = false
                        if (res.data) {
                            message.warning('参数错误,请检查')
                        } else {
                            message.warning(res.msg)
                        }
                    })
            }
        })
        .catch((res) => {
            message.warning('请检查表单必填项')
        })
}
const typeMap = new Map([
    [1, '投诉'],
    [2, '举报'],
    [3, '代办事项']
])
const titleformat = () => {
    if (state.isEdit == false) {
        if (formState.type == 1 || formState.type == 2) {
            formState.title = '【' + formState.tousu_name + (formState.tousu_tel ? ' ' + formState.tousu_tel : '') + '】' + typeMap.get(formState.type) + (formState.tousu_money ? '，涉及金额【' + formState.tousu_money + '元】' : '') + '，请及时处理'
        } else {
            formState.title = props.counterfeitInfo.full_name + '有' + typeMap.get(formState.type) + '，请及时处理'
        }
    }

}
</script>

<style lang="less" scoped>
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

.add-button {
    position: absolute;
    right: 65px;
    top: 10px;
}

.positionItem {
    display: inline-block;
    margin-bottom: 10px;
}
</style>
